import { render, staticRenderFns } from "./LearningGoalTestResultsUser.vue?vue&type=template&id=2fe2c288&"
import script from "./LearningGoalTestResultsUser.vue?vue&type=script&lang=js&"
export * from "./LearningGoalTestResultsUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports